import React from "react";
import styled from "styled-components";
import GlobalStyle from "../../../GlobalStyle";
import SendIcon from "../../../assets/img/CuratedContent/Send.svg";

const ButtonRightIconGreen = (props) => {
  const { label, icon, noIcon, disabled, iconStart } = props;
  return (
    <>
      <GlobalStyle />
      <Btn
        className={`${props.classBtn === undefined ? "" : props.classBtn}`}
        id={`${props.idBtn === undefined ? "" : props.idBtn}`}
        onClick={props.onClick}
        onBlur={props.onBlur}
        {...props}
      >
        {!noIcon && iconStart && (
          <span className={`icon ${props.classIcon === undefined ? "" : props.classIcon}`}>
            {icon ? <img src={icon} alt="icon" /> : <img src={SendIcon} alt="icon" />}
          </span>
        )}
        <span className="label">{label}</span>
        {!noIcon && !iconStart && (
          <span className={`icon ${props.classIcon === undefined ? "" : props.classIcon}`}>
            {icon ? <img src={icon} alt="icon" /> : <img src={SendIcon} alt="icon" />}
          </span>
        )}
      </Btn>
    </>
  );
};

ButtonRightIconGreen.defaultProps = {
  label: "Curation History",
};

export default ButtonRightIconGreen;

const Btn = styled.button`
  border-radius: 8px;
  background-color: #27ce0a;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  /* padding: 0 2px 0 16px; */
  ${(props) => (props.iconStart ? `padding: 0 2px 0 0px` : `padding: 0 2px 0 16px;`)}
  line-height: 20px;
  border: solid 1px #dadada;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "robotomedium";
  // margin-top: ${(props) => (props.marginTop ? props.marginTop : "3px")};
  /* height: 41px; */
  /* z-index: 15; */
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    font-size: 12px;
    line-height: 14px;
    border-radius: 6px;
    /* height: 31px; */
    margin-top: 0px;
  }
  /* if isLoading provided */
  ${(props) =>
    props.isLoading
      ? `
      opacity: 0.5;
      pointer-events: none;
    `
      : ""}
  /* if disabled provided */
  ${(props) =>
    props.disabled
      ? `
      &:disabled {
    cursor: default;
    pointer-events: none;
    opacity: 0.6;
  }
    `
      : ""}

${(props) =>
    props.enableZindex
      ? `
     z-index: ${props.enableZindex}
    `
      : ""}

  &:active,
  &:focus {
    box-shadow: 0 0 0 0.2rem rgb(40 167 69 / 50%);
  }
  &.white-btn {
    background-color: #fff;
    border: solid 1px #27ce0a;
    color: #27ce0a;
    span.label {
      color: #27ce0a;
    }
  }
  span.label {
    padding: 2px 0;
    float: left;
    margin-right: 13px;
    /* ${(props) => (props.iconStart ? `margin-left: 13px;` : `margin-right: 13px;`)} */
    color: #fff;
  }
  span.icon {
    display: flex;
    /* border-left: 1px solid #dddddd; */
    ${(props) => (props.iconStart ? `border-right: 1px solid #dddddd` : `border-left: 1px solid #dddddd;`)}
    padding: 1px 5px;
    margin: 8px 0px;
    height: 16px;
    float: left;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin: 6px 0px;
    }
    &.white-icon {
      border-left: 1px solid #27ce0a;
    }
    &.plus15 {
      /* height: 10px; */
      padding: 3px 8px;
      width: 30px;
      box-sizing: border-box;
      img {
        width: 11px;
        height: 11px;
      }
    }
    svg {
      float: left;
    }
  }
`;
